import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaArrowLeft } from "react-icons/fa";
import "../../../../UcafForm/styles.css";
import { printElementToPdf } from "../../../../UcafForm/printUtils";
import { DCAFData } from "./DcafForm";
import AppButton from "../../../../shared/AppButton";

function DcafPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const item = location.state?.item || {};

  const handlePrint = () => {
    const printContent = document.getElementById("print-content");
    if (!printContent) return;
    printElementToPdf("dcaf", printContent);
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="sticky top-0 z-50 bg-white border-b border-gray-200 px-4 py-3 flex justify-between items-center shadow-sm">
        <h2 className="text-xl font-bold text-gray-800">{t("DCAF 2.0")}</h2>
        <div className="flex gap-2">
          <AppButton
            variant="outlined"
            onClick={handleBack}
            startIcon={<FaArrowLeft />}
            label={t("Back")}
          />
          <AppButton onClick={handlePrint} label={t("Print")} />
        </div>
      </div>
      <div id="print-content" className="p-4 max-w-[1200px] mx-auto">
        <DCAFData item={item} />
      </div>
    </div>
  );
}

export default DcafPage;
